import React, { useEffect, useState } from "react";
import { Background } from "./LoginComp";
import { useForm } from "react-hook-form";
import {
  EyeIconWrapper,
  FloatLabelInput,
  LoadingButton,
} from "../../Utils/CustomComponent";
import { Button } from "react-bootstrap";
import PopupWrapper from "../../components/PopupWrapper";
import axios from "axios";
// import urls from "../../Utils/urls";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import Stepper from "@keyvaluesystems/react-stepper";
import FormBox from "../../components/FormBox/FormBox";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import PasswordChecklist from "react-password-checklist";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import urls from "../../Utils/urls";

const styles = {
  LineSeparator: () => ({
    backgroundColor: "#028A0F",
  }),
  ActiveNode: () => ({
    backgroundColor: "#ef8860",
  }),
  CompletedNode: () => ({
    backgroundColor: "#ef8860",
  }),
};

const BorrowerLogin = () => {
  const [steps, setSteps] = useState([
    {
      stepLabel: "Step 1",
      // stepDescription: "This is Step 1",
      completed: false,
    },
    {
      stepLabel: "Step 2",
      // stepDescription: "This is Step 1",
      completed: false,
    },
    {
      stepLabel: "Step 3",
      // stepDescription: "This is Step 1",
      completed: false,
    },
  ]);
  const [activeStep, setActiveStep] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [email, setEmail] = useState("");
  const [promptFail, setPromptFail] = useState(false);
  const [passwordsMatch, setPasswordsMatch] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [submitLoading1, setSubmitLoading1] = useState(false);
  const [step2Validated, setStep2Validated] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // const regex = /^\(?\d{3}\)?[ -.]?\d{3}[ -.]?\d{4}$/;
  const regex = /\(\d{3}\) \d{3}-\d{4}/;
  const createTicketFormSchema = {
    resolver: yupResolver(
      Yup.object().shape({
        first_name: Yup.string().required("First name Required"),
        last_name: Yup.string().required("Last name Required"),
        phone_number: Yup.string()
          .required("Phone number Required")
          .matches(regex, "Phone number is not valid!"),
      })
    ),
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    clearErrors,
    setError,
  } = useForm(createTicketFormSchema);

  const watchValue = watch();

  const lastStep = [
    "newpassword",
    "confirmPassword",
    "first_name",
    "last_name",
    "phone_number",
  ];
  const allFieldsFilled = lastStep.every(
    (field) => watchValue?.[field] !== "" && watchValue?.[field] !== undefined
    // &&
    // watchValue?.finalTerms !== false
  );

  useEffect(() => {
    if (watchValue?.newpassword === watchValue?.confirmPassword) {
      clearErrors("confirmPassword");
      setPasswordsMatch(true);
    } else {
      setPasswordsMatch(false);
    }
  }, [watchValue?.newpassword, watchValue?.confirmPassword]);

  // useEffect(() => {
  //   if (watchValue?.finalTerms) {
  //     setValue("terms", true);
  //   } else {
  //     setValue("terms", false);
  //   }
  // }, [watchValue?.finalTerms]);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    const newSteps = steps.map((step, idx) => ({
      ...step,
      completed: idx === 0 ? true : false,
    }));
    setSteps(newSteps);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    const newSteps = steps.map((step, idx) => ({
      ...step,
      completed: idx === activeStep - 1 ? false : step.completed,
    }));
    setSteps(newSteps);
  };

  // function handleCheck() {
  //   setShowPopup(true);
  // }

  async function onsubmit1() {
    setSubmitLoading(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const res = await axios.post(
        urls.newBorrowerLogin.login,
        // "https://api.loanlinq.com/api/v1/drupal-login",
        {
          username: email,
          password: watchValue?.password,
        },
        headers
      );
      const res1 = res?.data?.user?.roles;
      const roleCheck = Object?.values(res1);
      const containsBorrower = roleCheck.some((role) =>
        role.toLowerCase().includes("borrower")
      );
      setSubmitLoading(false);
      if (containsBorrower) {
        setPromptFail(false);
        setActiveStep(2);

        const newSteps = steps.map((step, idx) => ({
          ...step,
          completed: idx === 1 ? true : step.completed,
        }));
        setSteps(newSteps);
      } else {
        setPromptFail("You are not recognized as a borrower!");
      }
    } catch (error) {
      console.error(error, "error");
      setSubmitLoading(false);
      setPromptFail("Invalid username/Password!");
    }
  }

  const handleClick = async () => {
    if (!passwordsMatch) {
      setError("confirmPassword", {
        type: "manual",
        message: "Password and Confirm Password must match",
      });
    } else {
      setShowPopup(true);
    }
  };

  async function onSubmit(data) {
    setSubmitLoading1(true);
    if (!passwordsMatch) {
      setError("confirmPassword", {
        type: "manual",
        message: "Password and Confirm Password must match",
      });
      setSubmitLoading1(false);
    } else {
      const id = toast.loading("Onboarding borrower");
      const headers = {
        headers: {
          Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
        },
      };
      try {
        const response = await axios.post(
          urls.newBorrowerLogin.setPassword,
          {
            user_id: 0,
            password: data.confirmPassword,
            first_name: data.first_name,
            last_name: data.last_name,
            phone_number: data.phone_number,
            type: "E",
            email_address: email,
          },
          headers
        );

        setSubmitLoading1(false);
        // eslint-disable-next-line eqeqeq
        if (response.data.status == "200") {
          navigate("/login");
          const newSteps = steps.map((step, idx) => ({
            ...step,
            completed: idx === 2 ? true : step.completed,
          }));
          setSteps(newSteps);

          toast.update(id, {
            render: "Onboarded successfully!",
            type: "success",
            isLoading: false,
            ...commonToast,
          });
        }
      } catch (error) {
        console.error(error);
        setSubmitLoading1(false);
        setShowPopup(false);
        toast.update(id, {
          render: "Onboarding failed!",
          type: "error",
          isLoading: false,
          ...commonToast,
        });
      }
    }
  }
  function goToResetPage() {
    navigate("/reset-password");
  }
  return (
    <Background>
      <form className="w-75">
        <h3 className="pb-5 mb-5">Welcome to Borrower Onboarding</h3>
        {/* <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper> */}
        <Stepper
          steps={steps}
          currentStepIndex={activeStep}
          styles={styles}
          orientation="horizontal"
          labelPosition="bottom"
          errorSteps={[1]}
          errorStepColor="#f44336"
        />
        {activeStep === 0 && (
          <EmailComp
            handleNext={handleNext}
            activeStep={activeStep}
            setEmail={setEmail}
          />
        )}
        {activeStep === 1 && (
          <div>
            <div
              className="form-outline mb-5 mt-5 pb-5"
              style={{ position: "relative" }}
            >
              <FloatLabelInput
                register={{ ...register("password", { required: true }) }}
                label={"Password used in servicing.loans"}
                value={watchValue?.password}
                //   disabled={disableFWS}
                defaultValue={""}
                error={errors.password ? "Password Required" : ""}
                type={showPassword ? "text" : "password"}
              />
              <div
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "1rem",
                  cursor: "pointer",
                }}
                onClick={() => setShowPassword((pass) => !pass)}
              >
                {showPassword ? <Eye size={20} /> : <EyeSlash size={20} />}
              </div>
              <button
                type="button"
                value={"Forgot password?"}
                className="btn w-100 linkClick text-decoration-underline text-end p-0"
                data-bs-toggle="modal"
                data-bs-target="#forgotPasswordModal"
                // onClick={() => setViewAll(true)}
                onClick={() => goToResetPage()}
              >
                Forgot password?
              </button>
            </div>
            {promptFail && (
              <div className="alert alert-error text-center" role="alert">
                {promptFail}
              </div>
            )}
          </div>
        )}
        {activeStep === 2 && (
          <div>
            <FormBox
              options={additionalFields}
              register={register}
              watch={watch}
              setValue={setValue}
              errors={errors}
            />
            <EyeIconWrapper>
              <div className="form-outline mt-5">
                <FloatLabelInput
                  register={{ ...register("newpassword", { required: true }) }}
                  label={"Create new password"}
                  value={watchValue?.newpassword}
                  //   disabled={disableFWS}
                  defaultValue={""}
                  error={errors.newpassword ? "Password Required" : ""}
                  type="password"
                />
              </div>
            </EyeIconWrapper>
            <EyeIconWrapper>
              <div className="form-outline">
                <FloatLabelInput
                  register={{
                    ...register("confirmPassword", { required: true }),
                  }}
                  label={"Confirm new password"}
                  value={watchValue?.confirmPassword}
                  //   disabled={disableFWS}
                  defaultValue={""}
                  error={
                    errors.confirmPassword ? errors.confirmPassword.message : ""
                  }
                  type="password"
                />
              </div>
            </EyeIconWrapper>
            <PasswordChecklist
              rules={[
                "minLength",
                "specialChar",
                "number",
                "capitalAndLowercase",
                "match",
                "noSequence",
              ]}
              minLength={8}
              maxLength={30}
              value={watchValue?.newpassword || ""}
              valueAgain={watchValue?.confirmPassword}
              onChange={(isValid) => {
                if (isValid) setStep2Validated(true);
                else setStep2Validated(false);
              }}
              messages={{
                minLength: "Contain 8 to 30 characters",
                capitalAndLowercase: "Contain both lower and uppercase letters",
                number: "Contain 1 number",
                specialChar: "Contain 1 special character - !@#$%^&*()_+",
                noSequence:
                  "Not contain letter or number sequences like 'abc', '123', '4444', 'qwerty'",
              }}
              customRules={{
                noSequence: (password) => {
                  // Disallow common sequences like 'abc', '123', '4444', 'qwerty'
                  const disallowedPatterns = [
                    /(abc|123|qwerty)/i,
                    /(.)\1\1\1/, // Repeating characters like "4444"
                  ];
                  return !disallowedPatterns.some((pattern) =>
                    pattern.test(password)
                  );
                },
              }}
            />

            {/* <div className="form-group mb-5">
              <div className="form-check">
                <input
                  className="form-check-input"
                  //   register={{
                  //     ...register("terms", { required: true }),
                  //   }}
                  type="checkbox"
                  id={"terms"}
                  checked={watchValue?.finalTerms ? true : false}
                  onChange={(e) => {
                    handleCheck();
                  }}
                />
                <label className="form-check-label" htmlFor={"terms"}>
                  Agree Terms & Conditions
                </label>
              </div>
              <div className="invalid-feedback">
                {errors?.["terms"]?.message}
              </div>
            </div> */}
          </div>
        )}

        <div
          className="mt-5"
          style={{
            display: "flex",
            justifyContent: activeStep === 0 ? "end" : "space-between",
          }}
        >
          {/* {activeStep === 0 && (
            <Button onClick={handleNext} className="me-2">
              Next
            </Button>
          )} */}
          {activeStep > 0 && (
            <Button onClick={handleBack} className="me-2">
              Back
            </Button>
          )}
          {activeStep === 1 && (
            <LoadingButton
              loading={submitLoading}
              type="button"
              title={"Next"}
              disabled={!watchValue?.password}
              className="me-2"
              onClick={onsubmit1}
            />
            // <Button
            //   onClick={onsubmit1}
            //   className="me-2"
            //   disabled={!watchValue?.password}
            // >
            //   Next
            // </Button>
          )}
          {activeStep === 2 && (
            // <LoadingButton
            //   loading={submitLoading1}
            //   type="submit"
            //   title={"Submit"}
            //   disabled={!allFieldsFilled}
            //   className="me-2"
            //   onClick={handleSubmit(onSubmit)}
            // />
            <Button
              className="me-2"
              type="button"
              onClick={handleSubmit(handleClick)}
              disabled={!allFieldsFilled || !step2Validated}
            >
              Submit
            </Button>
          )}
        </div>
        <AgreePopup
          showPopup={showPopup}
          setShowPopup={setShowPopup}
          button={
            <LoadingButton
              loading={submitLoading1}
              type="submit"
              title={"Continue"}
              className="me-2"
              onClick={handleSubmit(onSubmit)}
            />
          }
          // check={
          //   <div className="form-group mb-5">
          //     <div className="form-check">
          //       <input
          //         className="form-check-input"
          //         register={{
          //           ...register("finalTerms", { required: true }),
          //         }}
          //         type="checkbox"
          //         id={"finalTerms"}
          //         checked={watchValue?.finalTerms}
          //         onChange={(e) => {
          //           setValue("finalTerms", e.target.checked);
          //         }}
          //       />
          //       <label
          //         className="form-check-label fw-bold"
          //         htmlFor={"finalTerms"}
          //       >
          //         Agree Terms & Conditions
          //       </label>
          //     </div>
          //     <div className="invalid-feedback">
          //       {errors?.["finalTerms"]?.message}
          //     </div>
          //   </div>
          // }
        />
      </form>
      <style>
        {` .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-active{
        color: #ef8860 !important;
      }

      .css-1u4zpwo-MuiSvgIcon-root-MuiStepIcon-root.Mui-completed {
        color: #ef8860 !important;
    }`}
      </style>
    </Background>
  );
};

export default BorrowerLogin;

const AgreePopup = ({ showPopup, setShowPopup, button }) => {
  return (
    <div>
      <PopupWrapper
        title="Attention!"
        extraClass="width-800"
        Component={
          <div>
            <p>
              We are excited to inform you about the launch of our new LoanlinQ
              portal. This portal is designed to provide you with an enhanced
              experience, offering better tools and resources to manage your
              loan efficiently.
            </p>
            <p className="fw-bold">
              Borrowers may join LoanlinQ any time before October 31st.
            </p>
            <p>
              Upon completing the steps to register on loanlinq.com, your
              account on{" "}
              <a href="https://servicing.loans">https://servicing.loans</a> will
              become restricted.
            </p>
            <p>
              <strong>
                Please note that our old portal will be shutting down on October
                31, 2024.{" "}
              </strong>
              We encourage you to transition to the new portal at your earliest
              convenience.
            </p>
            <p>
              <strong>*Note: </strong>Lenders & Brokers will be sent invitations
              via LoanlinQ to complete a comprehensive boarding process.
            </p>
            {/* {check} */}
            {button}
          </div>
        }
        toShow={showPopup}
        closeEventHandler={() => {
          setShowPopup(false);
        }}
      />
    </div>
  );
};

export const EmailComp = ({
  handleNext,
  activeStep,
  setEmail,
  label = "Enter servicing.loans borrower email address",
}) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm();

  const emailVal = watch("email");

  useEffect(() => {
    setEmail(emailVal);
  }, [emailVal]);

  return (
    <div>
      <div className="form-outline mb-5 mt-5 pb-5">
        <FloatLabelInput
          register={{
            ...register("email", {
              required: true,
              pattern:
                // eslint-disable-next-line no-useless-escape
                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            }),
          }}
          label={label}
          value={emailVal}
          //   disabled={disableFWS}
          defaultValue={""}
          error={errors.email ? "Email Required" : ""}
          type="email"
        />

        {/* <div className="mt-5 mb-3">
          Not a borrower? Please use this{" "}
          <a href="https://servicing.loans/">login</a> form.
        </div> */}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        {activeStep === 0 && (
          <Button onClick={handleSubmit(handleNext)} className="me-2">
            Next
          </Button>
        )}
      </div>
    </div>
  );
};

const additionalFields = [
  {
    title: "First Name",
    field: "first_name",
    type: "text",
    className: "col-12",
  },
  {
    title: "Last Name",
    field: "last_name",
    type: "text",
    className: "col-12",
  },
  {
    title: "Phone Number",
    field: "phone_number",
    type: "phoneNumber",
    className: "col-12",
  },
];
